import { render, staticRenderFns } from "./TemplatePositionEditor.vue?vue&type=template&id=73214228&scoped=true"
import script from "./TemplatePositionEditor.vue?vue&type=script&lang=js"
export * from "./TemplatePositionEditor.vue?vue&type=script&lang=js"
import style0 from "./TemplatePositionEditor.vue?vue&type=style&index=0&id=73214228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73214228",
  null
  
)

export default component.exports